import React, { useEffect, useState, Suspense } from "react";
import Header from "./BaseComponents/Header";
import HIFotterMain from "./BaseComponents/Footer";
import CategoryDisplayCel from "../BaseComponents/HomeCels/CategoryDisplayCel";
import SectionTitle from "../BaseComponents/SectionTitle";
import {
  getCategoryList,
  getOEMCategoryList,
  GetHiValuePlusHomePageData,
  GetHVPGetDealerCityList,
  hondaLogo,
  hiLogo,
  hiValuePlusLogo,
} from "../../networkCalls";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import { Modal } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import AboutUSCel from "../BaseComponents/HomeCels/AboutUSCel";
import EnqueyCel from "../BaseComponents/HomeCels/EnqueyCel";
import ExploreMore from "../BaseComponents/HomeCels/ExploreMore";
import FindDealerCel from "../BaseComponents/HomeCels/FindDealerCel";
import MainSlider from "./BaseComponents/MainSlider";
import SectionTitleComponent from "./BaseComponents/SectionTitle";
import WhyChoseUsCel from "../BaseComponents/HomeCels/WhyChoseUsCel";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import SEO from "../BaseComponents/SEO";
import OEMCategoryDisplayCel from "../BaseComponents/HomeCels/OEMCategoryDispalyCel";
import {
  VerifiedQualityIcon,
  AuthorizedDealersIcon,
  FairPricingIcon,
  TrustedCommunityIcon,
  LocationSearchIcon,
  SellProductIcon,
  TranparentIcon,
  EcofriendlyIcon,
  DollarSign,
  ShoppingCartIcon,
  TickIcon,
} from "./BaseComponents/icon";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  TextField,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CategoryView from "./BaseComponents/CategoryView";
import HiValueCategoryDisplayCel from "./BaseComponents/CategoryProductDisplayCel";
import Testimonial from "./BaseComponents/Testimonial";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { actionTypes, useStateValue } from "../../store";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';

const promise = getCategoryList();
const promise1 = GetHVPGetDealerCityList();
const promise2 = GetHiValuePlusHomePageData();
const promise3 = getOEMCategoryList();

const HIValuePlusHome = () => {
  const [
    {
      token,
      compareitemcount,
      huid,
      loginmodal,
      cartminisidebar,
      cartitemcount,
    },
    dispatch,
  ] = useStateValue();
  const [cookie] = useCookies(["hondaCookiee",
    //  "jwt", 
     "huid", "hdetial"]);
  const [catlist, setCatlist] = useState([]);
  const [oemlist, setoemList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(true);
  const [modalshow, setModalShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [bannerData, setBannerData] = useState([]);
  const [city, setCity] = useState([]);
  const [categoryList, setcategoryList] = useState([]);
  const [ImpressionList, setImpressionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    promise.then((data) => {
      setCatlist(data?.CategoryListArray);
      setIsLoading(false);
    });
    promise1.then((data) => {
      console.log("data is", data);
      const data1 = data?.data?.cityList?.map((item) => ({
        id: item.id,
        label: item.name,
        isMetro: item.isMetro,
        image: item.image,
      }));
      console.log("city list data", data1);
      setCity(data1);
      // setIsLoading(false);
    });
    promise2.then((res) => {
      console.log("response home page", res?.data?.bannersList);
      setBannerData(res?.data?.bannersList);
      setcategoryList(res?.data?.categoryList);
      setImpressionList(res?.data?.ImpressionList);

      // setCatlist(data?.CategoryListArray);
      setLoading(false);
    });
    promise3.then((data) => {
      console.log("data setCatlistOEM", data);
      setoemList(data?.OEMCategoryListArray);
    });
    if (cookie?.hondaCookiee) {
      setShow(false);
    }
  }, [catlist]);
  console.log("token is", token, typeof token);
  const [whyChoose, setWhyChoose] = useState([
    {
      icon: <VerifiedQualityIcon />,
      heading: "Verified Quality",
      desc: (
        <span>
          All products undergo rigorous quality checks
        </span>
      ),
    },
    {
      icon: <AuthorizedDealersIcon />,
      heading: "Authorized Dealers",
      desc: (
        <span>
          Buy and sell through authorized HI Value<sup>+</sup> dealers
        </span>
      ),
    },
    {
      icon: <TranparentIcon />,
      heading: "Assured Warranty",
      // heading: "Transparent Condition & Warranty",
      desc: (
        <span>
          6 Months Warranty by authorized HI Value<sup>+</sup> dealers
          {/* Clear details on product age,
          <br /> usage, condition-service history
          <br /> and warranty-no hidden information */}
        </span>
      ),
    },
    {
      icon: <FairPricingIcon />,
      heading: "Fair Deal",
      desc: (
        <span>
          Experience the
          hassle free way of
           Buy and Sell
        </span>
      ),
    },
    // {
    //   icon: <TrustedCommunityIcon />,
    //   heading: "Trusted Community",
    //   desc: (
    //     <span>
    //       Join thousands of satisfied
    //       <br /> customers in our
    //       <br /> marketplace
    //     </span>
    //   ),
    // },

    // {
    //   icon: <EcofriendlyIcon />,
    //   heading: "Eco-friendly & sustainable",
    //   desc: (
    //     <span>
    //       Promoted reuse of equipement,
    //       <br /> reduce waste, and supports
    //       <br /> more sustainable ecosystem
    //     </span>
    //   ),
    // },
  ]);
  const [value, setValue] = React.useState("");

  const btnmyaccount = () => {
    console.log("token is", token, typeof token);
    console.log("dsasdadsasdads");
    dispatch({ type: actionTypes.SET_LOGINMODAL, value: true });
  };
  const [cityvalue, setCityValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);
  const filter = createFilterOptions();
  const [showdesc, setShowDesc] = useState(false);
  console.log("city value", cityvalue);
  const steps = [
    { label: "Sell by\nCustomer" },
    { label: "Collection" },
    { label: "Inspection" },
    { label: "Repair with Genuine\nSpares" },
    { label: "Performance\nCheck" },
    { label: "Assured Warranty" },
    { label: "Buy by\nCustomer" },
    { label: "Assured Service" },
  ];
  return (
    <>
      {/* <SEO
        title="Generators|Tillers|Water Pumps|Brush Cutters|Lawn Mowers|General Purpose Engines|Outboard Motors"
        description="HIPP India's No. 1 power product company, is a subsidiary of Honda Motor Co. Japan. We have a wide & reliable product range of Portable Gensets, Water Pumps, Tiller, Brush Cutters, Lawnmowers & Outboard Motors."
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/"
        type="Website"
      /> */}
      <Header />
      <Suspense fallback={<div></div>}>
        <div className="d-flex  justify-content-center align-items-center ">
          <div className=" hivalueplusheadsection col-6">
            <h3 className="hivalueplusheadsectionheading">Authorized Refurbished Honda Power Products </h3>
            <p className="hivalueplusheadsectiondesc">Professionally inspected, expertly refurbished and warranty backed--delivering trusted Honda performance at unbeatable value.</p>
            <div className="w-100  row">
              <div className="col-lg-6 mt-2 mb-lg-2 d-flex align-items-center"> <CheckCircleIcon className="hivalueplustickicon" /><span className="hivalueheadsectionbullets">Verified Quality</span></div>
              <div className="col-lg-6 mt-2 mb-lg-2 d-flex align-items-center"> <CheckCircleIcon className="hivalueplustickicon" /><span className="hivalueheadsectionbullets">Assured Warranty</span></div>
              <div className="col-lg-6 mt-2 mb-lg-2 d-flex align-items-center"> <CheckCircleIcon className="hivalueplustickicon" /><span className="hivalueheadsectionbullets">Authorized Dealers</span></div>
              <div className="col-lg-6 mt-2 mb-lg-2 d-flex align-items-center"> <CheckCircleIcon className="hivalueplustickicon" /><span className="hivalueheadsectionbullets">Fair Deal</span></div>
            </div>

          </div>
          <div className="col-6 col-lg-6 col-md-6 mt-0  pt-3 pt-lg-0 pt-md-0 mt-lg-2">

            <MainSlider bannerData={bannerData} loading={loading} />
          </div>
        </div>
      </Suspense>
      {/* <div className="hivalueplussearchsection customdivcolor">
        <div className="container">
          <div className=" container">
            <div className="row container">
              <div className="col-12   mt-2 mb-2 d-flex align-items-center w-100">
                <div className="d-flex flex-column w-100">
                  <h2 className="text-start txtprimaryhivalueplus container f36 fw-bold ">
                    <span className="text-primary">ABOUT</span> US
                  </h2>
                 
                  <p className="f20 fw-semibold ">
                    The Trusted Platform for Refurbished Honda Power Products by authorized HI Value<sup>+</sup> dealer
                  </p>
                </div>
              </div>
              <div className="col-12   mt-2 mb-2">
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <p className=" f16 fw-normal hivalueaboutustext">
                    <div >

                      <div>
                       
                        Honda India Power products Ltd. supports both customers and dealers by providing a single unified platform for buying and selling refurbished Honda Power Products.
                        <span className={` pointer see_more ${!showdesc ? "d-inline" : "d-none"}`} onClick={() => { setShowDesc(true) }}>.. <span className="d-inline-flex align-items-center gap-2">See More <KeyboardArrowDownIcon /></span></span>
                      </div>
                    </div>
                    {showdesc && <br />}

                    {showdesc && <span className=" f16 fw-normal hivalueaboutustext">
                      Backed by trust, reliability and durability, every product listed on <span className="  fw-semibold text-black">
                        HI Value<sup>+</sup>
                      </span> platform undergoes checks by authorized  <span className=" text-black">
                        HI Value<sup>+</sup>
                      </span> dealer technicians.
                      {" "}
                     
                      <br />
                      <br />
                    </span>}
                    {showdesc && <span>
                      Buy refurbished or Sell used power products with complete peace of mind.

                     
                      <span className={`pointer  see_more ${showdesc ? "d-inline" : "d-none"}`} onClick={() => { setShowDesc(false) }}>.. <span className="d-inline-flex align-items-center gap-2">See Less <KeyboardArrowUpIcon /></span></span>
                    </span>}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="hivalueplussearchsections">
        <div className="container mt-2 mt-lg-5">
          <div className="row">
            <div className="col-6 col-lg-6 col-md-6 mt-2 mb-2">
              <div className="">
                <div className="hivalueplussection">
                  <div >


                    {/* ///////// */}



                    {/* ///////// */}
                    <div
                      className=" w-100 "
                    // style={{ marginBottom: "56px" }}
                    >
                      {/* <div className="bgbuysellicon">
                        <LocationSearchIcon />
                      </div> */}
                      <div className="d-flex justify-content-center align-items-center">
                        <p
                          className="buyNowBtn fw-bold  d-flex justify-content-center align-items-center gap-2 "
                          onClick={() => navigate("/hi-value-plus/products")}
                        >
                          <ShoppingCartIcon className="hiicon" size1={39} size2={36} />
                          Buy Now
                        </p>

                        {/* <p className="hivalueplusSectionDescription mb-0">
                          Quickly Explore refurbished Honda products for unbeatable value
                        </p> */}
                      </div>
                    </div>
                    {/* <div
                      className="hivalueplussectionBtn fw-bold d-flex justify-content-center align-items-center"
                      onClick={() => {
                        navigate("/hi-value-plus/products");
                      }}
                    >
                      <span
                        className="me-2"

                    
                      >
                        Get Started
                      </span>
                    </div> */}
                    {/* <div className="border rounded d-flex align-items-center p-2"   onClick={() => setModalShow(true)}>
                      <div
                        style={{ flex: 1 }}
                        onClick={() => setModalShow(true)}
                      >
                        <TextField
                          id="input-with-icon-textfield"
                          placeholder="Search your City..."
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <LocationOnOutlinedIcon />
                                </InputAdornment>
                              ),
                              disableUnderline: true,
                            },
                          }}
                          variant="standard"
                          sx={{
                            "& .MuiInputBase-root": {
                              border: "none",
                              outline: "none",
                            },
                          }}
                        />
                      </div>

                      <button className="hivaluebtn ms-2">
                        Browse Product
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-lg-6 col-md-6 mt-2 mb-2">
              <div className="">
                <div className="hivalueplussection">
                  <div >
                    <div
                      className="d-flex justify-content-center gap-3 align-items-start"
                    >

                      <p className="buyNowBtn fw-bold d-flex justify-content-center align-items-center gap-2 "
                        onClick={() => {
                          console.log("clicked !!!!");
                          if (!token) {
                            console.log("token is", token, typeof token);
                            dispatch({
                              type: actionTypes.SET_LOGINMODAL,
                              value: true,
                            });
                          } else {
                            navigate("/myaccount/sell-your-product");
                          }
                        }}>
                        {/* <div class="button-26__content">
                            <span class="button-26__text text"> */}
                        <DollarSign className="hiicon" size={35} />

                        Sell Now
                        {/* </span></div> */}
                      </p>
                      {/* <p className="hivalueplusSectionDescription mb-0">
                          Get fair value, instant support & Authorized dealer certified trust through <span>HI Value<sup>+</sup></span>
                        </p> */}
                      {/* </div> */}
                    </div>
                    {/* <div className="hivalueplussectionBtn fw-bold d-flex justify-content-center align-items-center">
                      <span
                        className="me-2"
                        onClick={() => {
                          console.log("clicked !!!!");
                          if (!token) {
                            console.log("token is", token, typeof token);
                            dispatch({
                              type: actionTypes.SET_LOGINMODAL,
                              value: true,
                            });
                          } else {
                            navigate("/myaccount/sell-your-product");
                          }
                        }}
                      // onClick={() =>
                      //   !token
                      //     ? () => {
                      //         console.log("token is", token, typeof token);
                      //         dispatch({
                      //           type: actionTypes.SET_LOGINMODAL,
                      //           value: true,
                      //         });
                      //       }
                      //     : navigate("/myaccount/sell-your-product")
                      // }
                      >
                        Get Started
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hivalueplussearchsection">
        <div className="container">
          <div className="d-flex align-items-center mb-3">
            <div className="text-capitalize me-2">
              <h4 className="d-flex align-items-center m-0 hivaluepluscategoryrangeheading">
                <img src={hiValuePlusLogo} className="headinglogoimg" />
                <span className="txtgray">Refurbished Category Range</span>{" "}
              </h4>
            </div>
            <div className="flex-grow-1 position-relative bg-border-mid"></div>
          </div>
          <div className="row g-3">
            {
              categoryList.map((value, idx) => {
                return (
                  <div className="col-lg-3 col-6 ">
                    <Link to={`/hi-value-plus/products?id=${value.id}`} className="hivaluepluscategoryrangebox d-flex flex-column  ">


                      <img
                        src={value?.image}
                        alt={value?.name}
                        className={`"d-block " `}
                        style={{ objectFit: "contain", }}
                      />
                      <div className="mt-2 mt-lg-0">{value.name}</div>
                    </Link>
                  </div>

                )
              })
            }

          </div>
        </div>
        {/* {categoryList && categoryList?.length > 0 ? (
          <>
            <CategoryView list={categoryList} />{" "}
          </>
        ) : null} */}
      </div>
      <div className="container hivalueplussearchsection">
        <div className="container">
          <div className="d-flex align-items-center mb-3">
            <div className="text-capitalize me-2">
              <h4 className="d-flex align-items-center m-0 hivaluepluscategoryrangeheading">
                <img src={hiValuePlusLogo} className="headinglogoimg" />
                <span className="txtgray">Why Choose Us</span>{" "}
              </h4>
            </div>
            <div className="flex-grow-1 position-relative bg-border-mid"></div>
          </div>
        </div>
        {/* <div className="">
          <h4 className="hivalueplussectiontitle text-start mb-3">
            Why Choose HI Value<sup>+</sup> ?
          </h4>
          <p className="hivaluepluswhychoosedesc">
            Trusted Platform for Honda refurbished products
          </p>
        </div> */}
        <div className="mt-3 row g-3">
          {whyChoose.map((val, idx) => (
            <div key={idx} className="col-lg-3 col-6">
              <div className=" position-relative overflow-hidden h-100 hivaluepluschooseusdivborder ">
                {/* Top SVG (absolute inside card) */}
                {/* <div
                  className="position-absolute w-100"
                  style={{ top: 0, left: 0 }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 283 29"
                    className="w-100 h-auto"
                    fill="none"
                  >
                    <path
                      d="M276 0H7C3.13401 0 0 3.134 0 7V12.8269H68.0864C69.9551 12.8269 71.6678 13.8689 72.5268 15.5285L79.5 29H283V7C283 3.13401 279.866 0 276 0Z"
                      fill="#0873BB"
                    />
                  </svg> */}
                {/* </div> */}

                {/* Content (relative, padded so it doesn't overlap svg) */}
                <div
                  className=" hivaluepluswhychooseitembox "
                >
                 <div className="d-flex flex-column flex-lg-row flex-md-row  align-items-center gap-2">

                  <div className=" hivalueimgchoose">{val.icon}</div>
                  <p className="hivaluepluswhychooseheading">{val.heading}</p>
                </div>
                 <p className="hivaluepluswhychoosedec mt-2">{val.desc}</p>
                </div>
                

                {/* Bottom strip */}
                {/* <div
                  className="position-absolute w-100"
                  style={{
                    bottom: 0,
                    left: 0,
                    height: "12px",
                    backgroundColor: "#0873BB",
                    borderBottomLeftRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                /> */}
              </div>
            </div>
          ))}
        </div>
      </div>



      <div className="hivalueplussearchsection">
      <div className="container">
          <div className="d-flex align-items-center mb-3">
            <div className="text-capitalize me-2">
              <h4 className="d-flex align-items-center m-0 hivaluepluscategoryrangeheading">
                <img src={hiValuePlusLogo} className="headinglogoimg" />
                <span className="txtgray">Refurbished Process</span>{" "}
              </h4>
            </div>
            <div className="flex-grow-1 position-relative bg-border-mid"></div>
          </div>
        </div>
        <div className="container">
          {/* <h2 className="text-center hivaluepluscategoryrangeheading mb-2">Refurbished Process</h2> */}

          <div className="hitimeline-wrapper">
            {steps.map((step, index) => (
              <div key={index} className="histep-item">
                {step.label === "Sell by\nCustomer" ? <div className="histepbuy d-flex align-items-center gap-1 px-3"> <DollarSign className="himatchicon" size={16} />

                  Sell</div> : step.label === "Buy by\nCustomer" ? <div className="histepbuy d-flex align-items-center gap-1 px-3"> <ShoppingCartIcon className="himatchicon" size1={19} size2={16} />
                    Buy</div> : <div className="histep-circle">
                  <TickIcon className={"histep-icon"} size={16}/>
                </div>}
                <div className={step.label === "Sell by\nCustomer" ? "histep-labels" : step.label === "Buy by\nCustomer" ? "histep-labels" : "histep-label"}>
                  {step.label === "Sell by\nCustomer" || step.label === "Buy by\nCustomer" ? "By Customer": step.label.replace('\n', " ")}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="d-flex align-items-center mb-3">
          <div className="text-capitalize me-2">
            <h4 className="d-flex align-items-center m-0 hivaluepluscategoryrangeheading">
              <img src={hiValuePlusLogo} className="headinglogoimg" />
              <span className="txtgray">Refurbished Product Range</span>{" "}
            </h4>
          </div>
          <div className="flex-grow-1 position-relative bg-border-mid"></div>
        </div>
      </div>
      {categoryList && categoryList?.length > 0 ? (
        <div className="mt60">
          <HiValueCategoryDisplayCel
            categoryList={categoryList}
            catlist={oemlist}
          />
        </div>
      ) : null}
      {ImpressionList.length > 0 && <div className="mt-2">
        <Testimonial ImpressionList={ImpressionList} />
      </div>}
      {/* <div className="mt-5 mb-5"></div> */}

      <Modal
        size="lg"
        show={show}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => handleClose()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => handleClose()}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="p-4">
            <div className="row">
              <div className="col-12">
                <h4 className="d-inline-block m-0 fw-bold text-uppercase">
                  <span className="txtred">BEWARE</span>{" "}
                  <span className="txtdgray">OF COUNTERFEITS</span>
                </h4>
              </div>
              <div className="col-12">
                <div className="mt-3">
                  <p>
                    <strong>Honda India Power Products Ltd.(HIPP) </strong>{" "}
                    (Formerly known as Honda Siel Power Products Ltd.) is a
                    leader in the Power Products industry for over 3 decades
                    engaged in the Manufacturing and Marketing of Portable
                    Generators, Water Pumps, Tillers &amp; General Purpose
                    Engines in India and abroad. We are also into the Marketing
                    of Lawn Mowers, Brush Cutter &amp; Long tailed boat engines.{" "}
                  </p>
                  <p>
                    All these products are marketed under the brand <b>HONDA</b>
                  </p>
                  <p>
                    We have come across instances of some unscrupulous parties
                    selling COUNTERFEIT <b>HONDA Power Products</b>. We are
                    alerting our valued customers, retailers and distributors
                    about this issue and simultaneously working to resolve it.
                  </p>
                  <p>
                    Kindly note that in the event of your having purchased a
                    fake HIPP product, HIPP will NOT be able to honor the
                    product warranty nor be responsible for the performance of
                    such counterfeit products.{" "}
                  </p>
                  <p>
                    We recommend that our valued customers exercise caution
                    while buying the aforementioned products.
                  </p>
                  <h5>HOW TO AVOID BUYING COUNTERFEITS</h5>
                  <ul>
                    <li>
                      Purchase HIPP products directly from an authorized HIPP
                      outlet, listed on our website: - www.hondaindiapower.com
                    </li>
                    <li>
                      Check the Trust-O-Gram (A 3D Sticker with Honda Logo and
                      Secure written on it) pasted on the Product which
                      qualifies it as GENUINE HONDA.
                    </li>
                    <li>
                      Call our Customer Care{" "}
                      <strong>Toll Free no. 1800-11-2323</strong> to check if
                      the outlet is authorized or not.
                    </li>
                  </ul>
                  <p>
                    For any clarification, please write to us at{" "}
                    <a href="mailto:customer.support@hipp.co.in">
                      customer.support@hipp.co.in
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="xl"
        centered
        show={modalshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded"
        onHide={() => setModalShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Header closeButton className="hivalueplusmodal border-0 p-4">
          <span className="hivalueplusmodalheader">Select Your City</span>
        </Modal.Header>
        <Modal.Body className="p-0">
          {/* <div
            onClick={() => setModalShow(false)}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div> */}
          <div className="px-4 pb-4 hivalueplusmodal">
            <div className="d-flex">
              <div style={{ flex: 1 }} className="me-2">
                <Autocomplete
                  options={city}
                  value={cityvalue}
                  inputValue={inputValue}
                  open={open}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);

                    setOpen(newInputValue.length > 0); // only open if typing
                  }}
                  onClose={() => setOpen(false)}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    setCityValue(newValue);
                  }}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  filterOptions={
                    (options, params) =>
                      params.inputValue === "" ? [] : filter(options, params) // filters by typed text
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select City"
                      className="w-100"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOnOutlinedIcon color="action" />
                          </InputAdornment>
                        ),
                        disableUnderline: true,
                      }}
                    />
                  )}
                />
              </div>
              <button
                className="bghivalueplus rounded border-0 px-3"
                onClick={() => {
                  cityvalue !== null &&
                    navigate("/hi-value-plus/products", {
                      state: { item: cityvalue },
                    });
                }}
              >
                <SearchIcon className="text-white" />
              </button>
            </div>
          </div>
          <div className="p-4">
            <div className="row">
              <div className="col-12 ">
                <p className="hivalueplusmodalheading">Popular Cities</p>
                <div className="row g-3">
                  {city && city?.length > 0
                    ? city
                      ?.filter((obj) => obj.isMetro === 1)
                      .map((item, index) => {
                        console.log("item is", item);
                        return (
                          <div
                            key={index}
                            className="col-12 col-lg-2 "
                            onClick={() => {
                              navigate("/hi-value-plus/products", {
                                state: { item },
                              });
                            }}
                          >
                            <div className="border pointer rounded p-2 text-center h-100 d-flex align-items-center justify-content-center">
                              <div className="d-flex   align-items-center f15 fw-normal">
                                <img
                                  src={item?.image}
                                  width={50}
                                  className="rounded-3 me-2"
                                />
                                {item.label}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <HIFotterMain />
    </>
  );
};
export default HIValuePlusHome;
